import { useEffect, useRef, useState } from 'react';

const useElementInView = (options: IntersectionObserverInit) => {
    const elementRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    const callbackFunction: IntersectionObserverCallback = entries => {
        const [entry] = entries;
        if (entry) {
            setIsVisible(entry.isIntersecting ?? false);
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(callbackFunction, options);
        const element = elementRef.current;
        if (element) {
            observer.observe(element);
        }
        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [options]);

    return {
        elementRef,
        visibleElementId: elementRef.current?.id ?? '',
        isVisible,
    };
};

export { useElementInView };
